import { combineReducers } from 'redux';
import helptext from './helptext';
import panelPermissions from './panelPermissions';
import masterConfig from './masterConfig';
import preferences from './preferences';
import transitions from './transitions';
import notificationsCount from './notificationsCount';
import themeConfigs from './themeConfigs';
export default combineReducers({
  helptext,
  panelPermissions,
  masterConfig,
  preferences,
  transitions,
  notificationsCount,
  themeConfigs
});